import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Video, Users } from 'lucide-react';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';

const Home = () => {
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState('');
  const [roomId, setRoomId] = useState('');
  const [password, setPassword] = useState('');
  const [requirePassword, setRequirePassword] = useState(false);
  const [joinPassword, setJoinPassword] = useState('');
  const [showJoinPassword, setShowJoinPassword] = useState(false);

  useEffect(() => {
    // Загружаем сохраненное имя из localStorage
    const savedName = localStorage.getItem('displayName');
    if (savedName) {
      setDisplayName(savedName);
    }
  }, []);

  const handleCreateRoom = () => {
    if (!displayName.trim()) {
      alert('Введите ваше имя');
      return;
    }
    
    // Сохраняем имя
    localStorage.setItem('displayName', displayName.trim());
    
    // Генерируем случайный ID комнаты
    const newRoomId = Math.random().toString(36).substring(2, 10);
    
    // Переходим в лобби с параметрами
    const roomPassword = requirePassword ? password : undefined;
    navigate(`/room/${newRoomId}`, {
      state: { 
        displayName: displayName.trim(),
        isHost: true,
        password: roomPassword,
        createRoom: true, // Флаг что это создание комнаты
      }
    });
  };

  const handleJoinRoom = () => {
    if (!displayName.trim()) {
      alert('Введите ваше имя');
      return;
    }
    if (!roomId.trim()) {
      alert('Введите ID комнаты');
      return;
    }
    
    // Сохраняем имя
    localStorage.setItem('displayName', displayName.trim());
    
    // Переходим в лобби с паролем (если введён)
    navigate(`/room/${roomId.trim()}`, {
      state: { 
        displayName: displayName.trim(),
        isHost: false,
        password: showJoinPassword && joinPassword ? joinPassword : undefined,
      }
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 via-gray-900 to-purple-900 p-4">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Video className="w-16 h-16 text-blue-500" />
          </div>
          <h1 className="text-5xl font-bold text-white mb-2">VideoConf</h1>
          <p className="text-gray-400 text-lg">Профессиональные видеоконференции</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* Создать комнату */}
          <div className="bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-700">
            <div className="flex items-center mb-6">
              <Video className="w-6 h-6 text-blue-500 mr-2" />
              <h2 className="text-2xl font-semibold text-white">Создать комнату</h2>
            </div>
            
            <div className="space-y-4">
              <Button 
                onClick={handleCreateRoom}
                className="w-full py-4 text-lg bg-blue-600 hover:bg-blue-700"
              >
                Быстрая встреча
              </Button>
              
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="requirePassword"
                  checked={requirePassword}
                  onChange={(e) => setRequirePassword(e.target.checked)}
                  className="w-4 h-4 text-blue-600 rounded"
                />
                <label htmlFor="requirePassword" className="text-sm text-gray-300">
                  Требуется пароль
                </label>
              </div>
              
              {requirePassword && (
                <Input
                  type="password"
                  placeholder="Пароль для комнаты"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              )}
            </div>
          </div>

          {/* Присоединиться */}
          <div className="bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-700">
            <div className="flex items-center mb-6">
              <Users className="w-6 h-6 text-green-500 mr-2" />
              <h2 className="text-2xl font-semibold text-white">Присоединиться</h2>
            </div>
            
            <div className="space-y-4">
              <Input
                type="text"
                placeholder="ID комнаты или ссылка"
                value={roomId}
                onChange={(e) => setRoomId(e.target.value)}
              />
              
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="showJoinPassword"
                  checked={showJoinPassword}
                  onChange={(e) => setShowJoinPassword(e.target.checked)}
                  className="w-4 h-4 text-green-600 rounded"
                />
                <label htmlFor="showJoinPassword" className="text-sm text-gray-300">
                  У комнаты есть пароль
                </label>
              </div>
              
              {showJoinPassword && (
                <Input
                  type="password"
                  placeholder="Пароль комнаты"
                  value={joinPassword}
                  onChange={(e) => setJoinPassword(e.target.value)}
                />
              )}
              
              <Button 
                onClick={handleJoinRoom}
                className="w-full py-4 text-lg bg-green-600 hover:bg-green-700"
              >
                Войти
              </Button>
            </div>
          </div>
        </div>

        {/* Общие настройки */}
        <div className="bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-700">
          <h3 className="text-lg font-semibold text-white mb-4">Ваши данные</h3>
          <Input
            type="text"
            placeholder="Введите ваше имя"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="max-w-md"
          />
          <p className="text-sm text-gray-400 mt-2">
            Вы сможете изменить имя во время конференции
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
